export default "/images/5ddb21f98ebda69582f8596e5b1c70ae.avif";